/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateParamsDto
 */
export interface CreateUpdateParamsDto {
    /**
     * Parameter group
     * @type {string}
     * @memberof CreateUpdateParamsDto
     */
    group: CreateUpdateParamsDtoGroupEnum;
    /**
     * Parameter name
     * @type {string}
     * @memberof CreateUpdateParamsDto
     */
    name: CreateUpdateParamsDtoNameEnum;
    /**
     * Parameter type
     * @type {string}
     * @memberof CreateUpdateParamsDto
     */
    type: CreateUpdateParamsDtoTypeEnum;
    /**
     * Parameter value
     * @type {string}
     * @memberof CreateUpdateParamsDto
     */
    valueString?: string;
    /**
     * Parameter value
     * @type {boolean}
     * @memberof CreateUpdateParamsDto
     */
    valueBoolean?: boolean;
    /**
     * Parameter value
     * @type {Date}
     * @memberof CreateUpdateParamsDto
     */
    valueDate?: Date;
    /**
     * Parameter value
     * @type {number}
     * @memberof CreateUpdateParamsDto
     */
    valueNumber?: number;
    /**
     * Is parameter editable
     * @type {boolean}
     * @memberof CreateUpdateParamsDto
     */
    isEditable: boolean;
    /**
     * Is parameter visible
     * @type {boolean}
     * @memberof CreateUpdateParamsDto
     */
    isVisible: boolean;
}


/**
 * @export
 */
export const CreateUpdateParamsDtoGroupEnum = {
    SYS: 'SYS',
    Reports: 'Reports',
    Invoicing: 'Invoicing'
} as const;
export type CreateUpdateParamsDtoGroupEnum = typeof CreateUpdateParamsDtoGroupEnum[keyof typeof CreateUpdateParamsDtoGroupEnum];

/**
 * @export
 */
export const CreateUpdateParamsDtoNameEnum = {
    JudgmentsLookbackMonths: 'JudgmentsLookbackMonths',
    TopCompaniesLimit: 'TopCompaniesLimit',
    ReportLastDays: 'ReportLastDays',
    FaceIdentityRetentionDays: 'FaceIdentityRetentionDays',
    AutomaticJudgmentDelayMinutes: 'AutomaticJudgmentDelayMinutes',
    ReferralFreshnessMonths: 'ReferralFreshnessMonths',
    AutomaticJudgmentRequireSignedExternalReferral: 'AutomaticJudgmentRequireSignedExternalReferral',
    WithoutJudgmentDays: 'WithoutJudgmentDays',
    AutoInvoiceMaxApprovalAmount: 'AutoInvoiceMaxApprovalAmount',
    AutoInvoiceDefaultPaymentDays: 'AutoInvoiceDefaultPaymentDays',
    AutoInvoiceErrorEmail: 'AutoInvoiceErrorEmail',
    AutoInvoiceDeadlineDayOfMonth: 'AutoInvoiceDeadlineDayOfMonth',
    SynevoOrderFee: 'SynevoOrderFee'
} as const;
export type CreateUpdateParamsDtoNameEnum = typeof CreateUpdateParamsDtoNameEnum[keyof typeof CreateUpdateParamsDtoNameEnum];

/**
 * @export
 */
export const CreateUpdateParamsDtoTypeEnum = {
    String: 'String',
    Boolean: 'Boolean',
    Number: 'Number',
    Date: 'Date'
} as const;
export type CreateUpdateParamsDtoTypeEnum = typeof CreateUpdateParamsDtoTypeEnum[keyof typeof CreateUpdateParamsDtoTypeEnum];


/**
 * Check if a given object implements the CreateUpdateParamsDto interface.
 */
export function instanceOfCreateUpdateParamsDto(value: object): value is CreateUpdateParamsDto {
    if (!('group' in value) || value['group'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('isEditable' in value) || value['isEditable'] === undefined) return false;
    if (!('isVisible' in value) || value['isVisible'] === undefined) return false;
    return true;
}

export function CreateUpdateParamsDtoFromJSON(json: any): CreateUpdateParamsDto {
    return CreateUpdateParamsDtoFromJSONTyped(json, false);
}

export function CreateUpdateParamsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateParamsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'group': json['group'],
        'name': json['name'],
        'type': json['type'],
        'valueString': json['valueString'] == null ? undefined : json['valueString'],
        'valueBoolean': json['valueBoolean'] == null ? undefined : json['valueBoolean'],
        'valueDate': json['valueDate'] == null ? undefined : (new Date(json['valueDate'])),
        'valueNumber': json['valueNumber'] == null ? undefined : json['valueNumber'],
        'isEditable': json['isEditable'],
        'isVisible': json['isVisible'],
    };
}

export function CreateUpdateParamsDtoToJSON(value?: CreateUpdateParamsDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'group': value['group'],
        'name': value['name'],
        'type': value['type'],
        'valueString': value['valueString'],
        'valueBoolean': value['valueBoolean'],
        'valueDate': value['valueDate'] == null ? undefined : ((value['valueDate']).toISOString()),
        'valueNumber': value['valueNumber'],
        'isEditable': value['isEditable'],
        'isVisible': value['isVisible'],
    };
}

